<template lang="pug">
div.eth-search-notice
  a.close(@click.prevent="searchVisible = false" v-if="searchVisible")
    inline-svg(:src="require('./close.svg')" width="21" height="21")



  template(v-if="!searchVisible")
    .text-wrapper
      .qicon ?
      i18n(tag="div" path="title1")
        template(v-slot:link)
          a(@click.prevent="showSearch" href="#") {{$t('Что делать?')}}
    //div Моя транзакция не приходит на счет.
      |
      |
      a(@click.prevent="showSearch" href="#") Что делать?
  eth-transaction-search(v-show="searchVisible")
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import EthTransactionSearch from "@/views/pages/finance/tools/EthTransactionSearch.vue";
import InlineSvg from 'vue-inline-svg';

@Component({
  name: "EthTransactionSearchNotice",
  components: {EthTransactionSearch, InlineSvg}
})
export default class EthTransactionSearchNotice extends Vue {

  searchVisible = false

  showSearch() {
    this.searchVisible = true;
  }

}
</script>

<style scoped lang="less">
.eth-search-notice {
  a {
    text-decoration: underline;
    &.close {
      text-decoration: none;
    }
  }

  position: relative;
  .close {
    position: absolute;
    right: 0;
    top: -5px;
    z-index: 1;
  }
}
.text-wrapper {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0 15px;
}

.qicon {
  display: grid;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #80bd1c;
  color: #fff;
  width: 20px;
  height: 20px;
}
</style>

<i18n>
{
  "en": {
    "title1": "My transaction is not credited to my account. {link}",
    "Моя транзакция не приходит на счет. Что делать?": "My transaction is not credited to my account. What to do?",
    "Что делать?": "What to do?"
  },
  "ru": {
    "title1": "Моя транзакция не приходит на счет. {link}"
  }
}
</i18n>
